<template>
  <div class="dem-rel-con" :key="cpntDemanda">
    <!-- SETA O STATUS DA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else>
      <div class="app-fil-rel-nov">
        <table>
          <tr class="n-col-3">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'select'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome' ]"
              :cpntNome="'Status'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.dem_sta"

              :cpntOnBuscarOptions="demRelPorPeriodoBuscarDemandaStatus"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'dem_sta') }"
              ref="dem_sta"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'seletor-data'"
              :cpntNome="''"
              :cpntTodos="'Todas as datas'"
              :cpntValue="filtros.dat"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'dat') }"
              ref="dat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'select'"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome' ]"
              :cpntNome="'Tipo de Relatório'"
              :cpntTodos="''"
              :cpntValue="filtros.tprel"

              :cpntOnBuscarOptions="demRelPorPeriodoBuscarTipoRelatorio"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'tprel') }"
              ref="dem"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table>
          <tr :class="'n-col-' + demRelPorPeriodoContarColunasLinha1">
            <td :colspan="(4 - demRelPorPeriodoContarColunasLinha1)">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Documento', chave: 'cnpj_cpf' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]"
              :cpntNome="'Contatos'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.con"
              :cpntNenhum="false"

              :cpntRouter="'/contato/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, empresa: null, cnpj_cpf: null }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'con') }"
              ref="con"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.vei === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Placa', chave: 'placa' }, { nome: 'Marca', chave: 'id_mar_nome' }, { nome: 'Modelo', chave: 'id_mod_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'demandaId_id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ]"
              :cpntNome="'Veículo'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.vei"
              :cpntNenhum="true"

              :cpntRouter="'/veiculo/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, placa: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'vei') }"
              ref="vei"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.pet === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' }, { nome: 'Raça', chave: 'id_pet_subespecie_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'demandaId_id_con_nome' ]"
              :cpntNome="'Pet'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pet"
              :cpntNenhum="true"

              :cpntRouter="'/pet/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'pet') }"
              ref="pet"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table v-if="permissoes.pro === true">
          <tr class="n-col-3">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_cat"
              :cpntNenhum="false"

              :cpntRouter="'/produto/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'pro_cat') }"
              ref="pro_cat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Marca Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_mar"
              :cpntNenhum="false"

              :cpntRouter="'/produto/marca/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'pro_mar') }"
              ref="pro_mar"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'codigo' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ]"
              :cpntNome="'Produto'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pro"
              :cpntNenhum="true"

              :cpntRouter="'/produto/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } }"
              :cpntWhere="() => { return demRelPorPeriodoMontarWhereFiltro('pro') }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'pro') }"
              ref="pro"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table v-if="permissoes.ser === true">
          <tr class="n-col-2">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Serviço'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.ser_cat"
              :cpntNenhum="false"

              :cpntRouter="'/servico/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'ser_cat') }"
              ref="ser_cat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'id' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id' ]"
              :cpntNome="'Serviço'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.ser"
              :cpntNenhum="true"

              :cpntRouter="'/servico/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_cat: { j: { nome: null } } }"
              :cpntWhere="() => { return demRelPorPeriodoMontarWhereFiltro('ser') }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorPeriodoAtualizarFiltro(value, 'ser') }"
              ref="ser"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>
      </div>

      <!-- SETA O BOTÃO PESQUISAR -->
      <div class="dem-rel-con-pes">
        <!-- SETA O BOTÃO PESQUISAR -->
        <App-Button :cpntStatus="pesquisa === 'carregando' ? pesquisa: ''" :cpntClass="'btn btn-primary'" @onClick="() => { demRelPorPeriodoPesquisar() }">Pesquisar</App-Button>

        <!-- SETA O BOTÃO MINHA PERSONALIZAÇÃO -->
        <App-Minha-Personalizacao v-if="[ '', null, undefined ].indexOf(mper.tabper) === -1 && pesquisa !== null && pesquisa !== 'carregando'"
        :cpntMper='mper.tabper'
        :cpntMperRpp='mper.rpp'
        :cpntMperOrder='mper.order'
        :cpntMperOrderOptions='mper.orderOptions'
        :cpntMperField='mper.field'
        :cpntMperFieldOptions='mper.fieldOptions'
        :cpntMperFiltro='mper.filtro'

        @UPDATE='() => { demRelPorPeriodoPesquisar() }'
        ></App-Minha-Personalizacao>
      </div>

      <!-- SETA O RESULTADO DA TELA -->
      <div class="dem-rel-con-res" v-if="pesquisa !== null">
        <!-- SETA O STATUS DA TELA -->
        <RF-Status v-if='pesquisa !== ""' :cpntStatus='pesquisa' :cpntTamanho='5'></RF-Status>

        <!-- SETA OS DADOS DA TELA -->
        <template v-else>
          <!-- SETA O LOCAL DO GRAFICO -->
          <!-- <div v-if="grafico !== null" class="grafico">
            <div v-if="params.qtdeG >= params.limitG" style="text-align: center; background: #e9e9e9; border: 1px solid #ccc; border-radius: 10px; padding: 40px 10px; width: 60%; margin: 0px auto;">
              OPS: O gráfico só pode ser gerado para quantidade de registros inferior a {{ params.limitG }} (Utilize mais filtros). 
            </div>
            <template v-else>
              <canvas ref="grafico" width="1000" height="300" style="position: relative; z-index: 1;"></canvas>
            </template>
          </div> -->
          <div v-if="grafico !== null" class="grafico">
            <canvas ref="grafico" width="1000" height="300" style="position: relative; z-index: 1;"></canvas>
          </div>

          <!-- VERIFICA SE ULTRAPASSOU O LIMITE DE LINHAS -->
          <!-- <div v-if="params.qtdeT >= params.limitT" style="text-align: center; background: #e9e9e9; border: 1px solid #ccc; border-radius: 10px; padding: 40px 10px; width: 60%; margin: 0px auto;">
            OPS: A tabela só pode ser gerada para quantidade de colunas inferior a {{ params.limitT }} (Utilize mais filtros). 
          </div> -->
          <div v-if="(params.qtdeT * linhas.length) >= params.limitCel" style="text-align: center; background: #e9e9e9; border: 1px solid #ccc; border-radius: 10px; padding: 40px 10px; width: 60%; margin: 0px auto;">
            OPS: A tabela só pode ser gerada para quantidade de celulas inferior a {{ params.limitCel }} (Utilize mais filtros). 
          </div>

          <!-- <div v-else-if="linhas.length === 0" style="text-align: center;">
            Nenhum registro encontrado.
          </div> -->

          <!-- SETA A TABELA NA TELA -->
          <App-Demanda-Relatorio-Por-Periodo-Tabela v-else
          :cpntDemanda="cpntDemanda"
          :cpntLinhas="linhas"
          :cpntColunas="colunas"
          :cpntFiltros="filtros"
          @UPDATE_TOTAIS="(value) => { demRelPorPeriodoSetarTotais(value) }"
          @UPDATE_TABELA="() => { demRelPorPeriodoPesquisar() }"
          ></App-Demanda-Relatorio-Por-Periodo-Tabela>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dem-rel-con-pes {
    text-align: center;
    margin: 10px 0px;
  }
  .dem-rel-con-res > div {
    padding: 10px 0px;
  }
    .dem-rel-con-res > .grafico > div {
      width: 200px;
      margin-left: 15px;
      margin-bottom: 15px;
    }
</style>

<style>
</style>

<script>
  var moment = require('moment')

  export default {
    props: {
      cpntDemanda: {
        requeire: true
      }
    },
    components: {
      'App-Minha-Personalizacao': () => import('@/components/_geral/Minha-Personalizacao.vue'),
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Demanda-Relatorio-Por-Periodo-Tabela': () => import('@/components/demanda/Relatorio/Demanda-Relatorio-Por-Periodo-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        pesquisa: null,
        grafico: null,
        linhas: [],
        colunas: [],
        filtros: {
          dem_sta: [ '2' ],
          dat: '40',
          tprel: '2',
          con: '',
          pet: '',
          vei: '',
          pro: '',
          pro_cat: '',
          pro_mar: '',
          ser: '',
          ser_cat: ''
        },
        params: {
          qtdeG: 0,
          limitG: 750,
          qtdeT: 0,
          limitT: 750,
          limitCel: 25000,
          qtdeC: 0,
          qtdeMes: null,
          dataIni: '',
          dataFim: ''
        },
        mper: {
          tabper: '',
          rpp: true,
          order: true,
          orderOptions: [],
          field: true,
          fieldOptions: [],
          filtro: false,
        },
        permissoes: {
          vei: false,
          pet: false,
          pro: false,
          ser: false
        }
      }
    },
    mounted: function () {
      this.demRelPorPeriodoIniciar()
    },
    methods: {
      demRelPorPeriodoIniciar: function () {
        // SETA O STATUS DA TELA
        this.demRelPorPeriodoSetarStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA VERIFICAR AS PERMISSÕES
        this.demRelPorPeriodoVerificarPermissao()

        // LIMPA AS VARIAVEIS
        this.mper.tabper = ''
        this.mper.rpp = false
        this.mper.order = false
        // this.mper.orderOptions = [
        //   { id: '0', nome: 'Maior Quantidade Vendido Decrescente' },
        //   { id: '1', nome: 'Maior Quantidade Vendido Crescente'   },
        //   { id: '2', nome: 'Maior Valor Vendido Decrescente'      },
        //   { id: '3', nome: 'Maior Valor Vendido Crescente'        },
        //   { id: '4', nome: 'Ordem Alfabética Item'                },
        //   { id: '5', nome: 'Ordem Alfabética Item'                },
        //   { id: '6', nome: 'Código Item Decrescente'              },
        //   { id: '7', nome: 'Código Item Crescente'                }
        // ]
        this.mper.field = true
        this.mper.fieldOptions = [
          { mPer: 1, chave: 'item_tipo',              nome: 'Tipo'        },
          { mPer: 1, chave: 'item_codigo',            nome: 'Cod.'        },
          { mPer: 2, chave: 'item_nome',              nome: 'Nome'        },
          { mPer: 1, chave: 'item_id_cat_nome',       nome: 'Categoria'   },
          { mPer: 1, chave: 'item_id_mar_nome',       nome: 'Marca'       },
        ]

        // VERIFICA QUAL É A PERSONALIZAÇÃO QUE DEVE REALIZAR
        switch (this.cpntDemanda) {
          case 'venda':
            this.mper.tabper = 'VendaPorPeriodo'
            break

          case 'compra':
            this.mper.tabper = 'CompraPorPeriodo'
            break
        }

        // CARREGA A MINHA PERSONALIZAÇÃO
        this.demRelPorPeriodoBuscarValorMper().then(() => {
          // SETA O STATUS DA TELA
          this.demRelPorPeriodoSetarStatusGeral('')

          // MANDA FAZER A PESQUISA NA TELA
          // this.demRelPorPeriodoPesquisar()
        })
      },
      demRelPorPeriodoBuscarValorMper: function () {
        return new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.mper.tabper) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.mPer[this.mper.tabper]) === -1) {
            success()
          } else {
            this.$store.state.comunicaAPI('/config/mper/get/', 'GET', this.mper.tabper, (retorno) => {
              // INICIA O VETOR DE PERSONALIZAÇÃO
              var vetor = { field: '', rpp: '10', order: '0', flag: false, filtro: '' }
    
              // VERIFICA SE EXISTE O FILTRO
              retorno.data.filtro = ''
              if ([ '', null, undefined ].indexOf(retorno.data.id_cg_filtro_j_filtro) === -1) {
                // CONVERTE O VALOR RECEBIDO
                retorno.data.id_cg_filtro_j_filtro.j_filtro = JSON.parse(retorno.data.id_cg_filtro_j_filtro.j_filtro)
    
                // PEGA O VALOR CONVERTIDO
                retorno.data.filtro = JSON.parse(JSON.stringify(retorno.data.id_cg_filtro_j_filtro))
    
                // DELETA O VALOR NÃO UTILIZADO MAIS
                delete retorno.data.id_cg_filtro_j_filtro
              }
    
              // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
              var flag = Object.values(retorno.data).filter(item => [ '', null, undefined ].indexOf(item) === -1).length >= 1
    
              // VERIFICA SE FOI ENCONTRADO ALGUMA PERSONALIZAÇÃO
              if (flag === true) {
                vetor = retorno.data
                vetor.flag = true
              }
    
              // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
              this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: this.mper.tabper, dados: vetor })
        
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              success()
            }, this.demRelPorPeriodoSetarStatusGeral)
          }
        })
      },
      demRelPorPeriodoVerificarPermissao: function () {
        // VERIFICA SE TEM PERMISSÃO VEICULO
        this.permissoes.vei = this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PET
        this.permissoes.pet = this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PRODUTO
        this.permissoes.pro = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO SERVIÇO
        this.permissoes.ser = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true
      },
      demRelPorPeriodoBuscarDemandaStatus: function (callback) {
        // INICIA A VARIAVEL OPTIONS
        var options = []

        // VERIFICA AS OPÇÕES DO CAMPO
        switch (this.cpntDemanda) {
          case 'venda':
            options = options.concat([
              { id: '1', nome: 'Orçamento de Venda' },
              { id: '2', nome: 'Venda' }
            ])
            break

          case 'compra':
            options = options.concat([
              { id: '1', nome: 'Orçamento de Compra' },
              { id: '2', nome: 'Compra' }
            ])
            break
        }

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      demRelPorPeriodoBuscarTipoRelatorio: function (callback) {
        // INICIA A VARIAVEL DE OPÇÕES
        var options = [
          { id: '1', nome: 'Ticket médio diário' },
          { id: '4', nome: 'Ticket médio mensal' },
          { id: '2', nome: 'Valor total diário' },
          { id: '5', nome: 'Valor total mensal' },
          { id: '3', nome: 'Quantidade diária' },
          { id: '6', nome: 'Quantidade mensal' }
        ]

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      demRelPorPeriodoMontarWhereFiltro: function (campo) {
        // INICIA A VARIAVEL WHERE
        var where = {} 
        
        // SETA O VALOR DE CADA CAMPO
        switch (campo) {
          case 'pro':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.pro_cat.join() })
            }

            // VERIFICA SE TEM QUE FILTRAR MARCA
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ f: 'id_mar', o: '=', v: this.filtros.pro_mar.join() })
            }
            break

          case 'ser':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.ser_cat.join() })
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return where
      },
      demRelPorPeriodoAtualizarFiltro: function (value, chave) {
        if ([ 'tprel', 'dat'].indexOf(chave) === -1 || (['tprel', 'dat'].indexOf(chave) !== -1 && value !== '')) {
          // SETA O NOVO VALOR DO FILTRO
          this.filtros[chave] = value
  
          // VERIFICA A AÇÃO PERSONALIZADA QUE DEVE REALIZAR
          switch (chave) {
            case 'pro_cat':
            case 'pro_mar':
              this.filtros.pro = ''
              break
  
            case 'ser_cat':
              this.filtros.ser = ''
              break
          }
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      demRelPorPeriodoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelPorPeriodoMontarDataIniDataFimPesquisa: function (dataIni, dataFim) {
        // VERIFICA SE TEM DATA INICIAL E NÃO TEM DATA FINAL
        if ([ '', null, undefined, NaN ].indexOf(dataIni) === -1 && [ '', null, undefined, NaN ].indexOf(dataFim) !== -1) {
          dataFim = dataIni
        }
        
        // CALCULA A DIFERENÇA DE MESES
        this.params.qtdeMes = Math.ceil(moment(dataFim, 'DD/MM/YYYY').diff(moment(dataIni, 'DD/MM/YYYY'), 'months', true))

        // SETA A DATA INICIAL
        this.params.dataIni = dataIni

        // SETA A DATA INICIAL
        this.params.dataFim = dataFim

        // PEGA O TIPO DE RELATORIO
        var tprel = typeof this.filtros.tprel === 'string' ? this.filtros.tprel : this.filtros.tprel.id

        // VERIFICAR 
        var modo = ''

        // VERIFICA O TIPO DE RELATORIO QUE SERÁ MONTADO
        switch (tprel) {
          case '1':
          case '2':
          case '3':
            modo = { diff: 'days', add: 'd' }
            break

          case '4':
          case '5':
          case '6':
            modo = { diff: 'months', add: 'M' }
            break
        }
        
        // CALCULA A QUANTIDADE DE MESES
        this.params.qtdeC = Math.ceil(moment(this.params.dataFim, 'DD/MM/YYYY').diff(moment(this.params.dataIni, 'DD/MM/YYYY'), modo.diff, true))

        // CALCULA OS DIAS
        if ([ '1', '2', '3' ].indexOf(tprel) !== -1) {
          this.params.qtdeC = (this.params.qtdeC + 1)
        }
      },
      demRelPorPeriodoMontarRouter: function (demanda) {
        // INICIA A VARIAVEL
        var rota = {}

        // FAZ AS VERIFICAÇÕES
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
          case 'venda_produto_data_ini_fim':
            rota = '/venda/produto/get'
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
          case 'venda_servico_data_ini_fim':
            rota = '/venda/servico/get'
            break

          case 'compra_produto':
          case 'compra_produto_grafico':
          case 'compra_produto_data_ini_fim':
            rota = '/demanda/dem-compra/dem-produto/get'
            break
        }

        // RETORNA A ROTA MONTADA
        return rota
      },
      demRelPorPeriodoMontarMethod: function (demanda) {
        // INICIA A VARIAVEL
        var metodo = ''

        // FAZ AS VERIFICAÇÕES
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
          case 'venda_produto_data_ini_fim':
          case 'venda_servico':
          case 'venda_servico_grafico':
          case 'venda_servico_data_ini_fim':
          case 'compra_produto':
          case 'compra_produto_grafico':
          case 'compra_produto_data_ini_fim':
            metodo = 'POST'
            break
        }

        // RETORNA O VALOR MONTADO
        return metodo
      },
      demRelPorPeriodoMontarField: function (demanda) {
        // INICIA A VARIAVEL
        var field = {}

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda) {
          case 'venda_produto':
            field = {
              id_pro: { j: { 
                id: { a: 'item' }, 
                codigo: { a: 'item_codigo' }, 
                nome: { a: 'item_nome' }, 
                id_cat: { j: { nome: { a: 'item_id_cat_nome' } } }, 
                id_mar: { j: { nome: { a: 'item_id_mar_nome' } } }, 
                status: { a: 'item_status' }
              } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              cod_venda: { a: 'demandaId_count', o: 'count', j: { 
                cod_venda: { a: 'demandaId' }, 
                vencimento: { a: 'demandaId_data', o: [ 'year', 'month', 'day' ] }, 
                status: { a: 'demandaId_status' }, 
                id_con: { j: {
                  id: { a: 'demandaId_id_con' }, 
                  nome: { a: 'demandaId_id_con_nome' }, 
                  empresa: { a: 'demandaId_id_con_empresa' }, 
                  pessoa: { a: 'demandaId_id_con_pessoa' }, 
                  status: { a: 'demandaId_id_con_status' }
                }
              } } }
            }
            break
          case 'venda_produto_grafico':
            field = {
              id_pro: { j: { id: { a: 'item' }, } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              cod_venda: { a: 'demandaId_count', o: 'count', j: { 
                id_con: { j: {
                  id: { a: 'demandaId_id_con' }, 
                  nome: { a: 'demandaId_id_con_nome' }, 
                  empresa: { a: 'demandaId_id_con_empresa' }, 
                  pessoa: { a: 'demandaId_id_con_pessoa' }, 
                  status: { a: 'demandaId_id_con_status' }
                }
              } } }
            }
            break
          case 'venda_produto_data_ini_fim':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break

          case 'venda_servico':
            field = {
              id_ser: { j: { 
                id: { a: 'item_codigo' }, 
                nome: { a: 'item_nome' }, 
                id_cat: { j: { nome: { a: 'item_id_cat_nome' } } }, 
                status: { a: 'item_status' }
              } },
              qtde: { o: 'sum' },
              valor_tot: { o: 'sum' },
              cod_venda: { a: 'demandaId_count', o: 'count', j: { 
                cod_venda: { a: 'demandaId' }, 
                vencimento: { a: 'demandaId_data', o: [ 'year', 'month', 'day' ] }, 
                status: { a: 'demandaId_status' }, 
                id_con: { j: {
                  id: { a: 'demandaId_id_con' }, 
                  nome: { a: 'demandaId_id_con_nome' }, 
                  empresa: { a: 'demandaId_id_con_empresa' }, 
                  pessoa: { a: 'demandaId_id_con_pessoa' }, 
                  status: { a: 'demandaId_id_con_status' }
                }
              } } }
            }
            break
          case 'venda_servico_grafico':
            field = {
              id_ser: { j: { id: { a: 'item' }, } },
              qtde: { o: 'sum' },
              valor_tot: { o: 'sum' },
              cod_venda: { a: 'demandaId_count', o: 'count', j: { 
                id_con: { j: {
                  id: { a: 'demandaId_id_con' }, 
                  nome: { a: 'demandaId_id_con_nome' }, 
                  empresa: { a: 'demandaId_id_con_empresa' }, 
                  pessoa: { a: 'demandaId_id_con_pessoa' }, 
                  status: { a: 'demandaId_id_con_status' }
                }
              } } }
            }
            break
          case 'venda_servico_data_ini_fim':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_ser: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' } } }
            }
            break

          case 'compra_produto':
            field = {
              id_pro: { j: { 
                id: { a: 'item' }, 
                codigo: { a: 'item_codigo' }, 
                nome: { a: 'item_nome' }, 
                id_cat: { j: { nome: { a: 'item_id_cat_nome' } } }, 
                id_mar: { j: { nome: { a: 'item_id_mar_nome' } } }, 
                status: { a: 'item_status' }
              } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              dem_compra: { a: 'demandaId_count', o: 'count', j: { 
                dem_compra: { a: 'demandaId' }, 
                vencimento: { a: 'demandaId_data', o: [ 'year', 'month', 'day' ] }, 
                dem_status: { a: 'demandaId_status' }, 
                id_con: { j: {
                  id: { a: 'demandaId_id_con' }, 
                  nome: { a: 'demandaId_id_con_nome' }, 
                  empresa: { a: 'demandaId_id_con_empresa' }, 
                  pessoa: { a: 'demandaId_id_con_pessoa' }, 
                  status: { a: 'demandaId_id_con_status' }
                }
              } } }
            }
            break
          case 'compra_produto_grafico':
            field = {
              id_pro: { j: { id: { a: 'item' }, } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              dem_compra: { a: 'demandaId_count', o: 'count', j: { 
                id_con: { j: {
                  id: { a: 'demandaId_id_con' }, 
                  nome: { a: 'demandaId_id_con_nome' }, 
                  empresa: { a: 'demandaId_id_con_empresa' }, 
                  pessoa: { a: 'demandaId_id_con_pessoa' }, 
                  status: { a: 'demandaId_id_con_status' }
                }
              } } }
            }
            break
          case 'compra_produto_data_ini_fim':
            field = {
              dem_compra: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break    
        }

        // RETORNA OS FIELDS MONTADOS
        return field
      },
      demRelPorPeriodoMontarWhere: function (demanda) {
        // INICIA A VARIAVEL
        var model = ''

        // INICIA O WHERE QUE SERÁ REALIZADO
        var where = {}

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
          case 'venda_produto_data_ini_fim':
            // SETA O MODEL
            model = 'venda'

            // INICIA O WHERE
            where = { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { m: model, f: 'status', o: '<>', v: '3' } ,
            ] }
            
            // VERIFICA POSSIVEL PERSONALIZAÇÃO
            if ([ '2298', '8007', '1933' ].indexOf(this.$store.state.token.clu) !== -1) {
              where.aAnd.push({
                aOr: [
                  { m: model, f: 'p_doc_ope', o: 'isNull' },
                  { m: model, f: 'p_doc_ope', o: '=', v: '1' },
                  { m: model, f: 'p_doc_ope', o: '=', v: '0' }
                ]
              })
            } else {
              where.aAnd.push({
                aOr: [
                  { m: model, f: 'p_doc_ope', o: 'isNull' },
                  { m: model, f: 'p_doc_ope', o: '=', v: '1' }
                ]
              })
            }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              where.aAnd.push({ m: model, f: 'status', o: '=', v:  this.filtros.dem_sta.join() })
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: model, f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: model, f: 'id_vei', o: '=', v: '0' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: model, f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }

            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: model, f: 'id_pet', o: 'isNull' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: model, f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: model, f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: model, f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
          case 'venda_servico_data_ini_fim':
            // SETA O MODEL
            model = 'venda'

            // INICIA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'venda', f: 'status', o: '<>', v: '3' } ] }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v:  this.filtros.dem_sta.join() })
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }

            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: '=', v: '' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.ser !== '') {
              where.aAnd.push({ f: 'id_ser', o: 'in', v: this.filtros.ser.join() })
            }
    
            // SETA A BUSCA DO CATEGORIA DE SERVIÇO ESPECIFICADO
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ m: 'servico', f: 'id_cat', o: 'in', v: this.filtros.ser_cat.join() })
            }

            
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'compra_produto':
          case 'compra_produto_grafico':
          case 'compra_produto_data_ini_fim':
            // SETA O MODEL
            model = 'demanda'

            // INICIA O WHERE
            where = { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { m: model, f: 'dem_status', o: '<>', v: '3' } ,
            ] }
            
            // VERIFICA POSSIVEL PERSONALIZAÇÃO
            if ([ '2298', '8007', '1933' ].indexOf(this.$store.state.token.clu) !== -1) {
              where.aAnd.push({
                aOr: [
                  { m: model, f: 'p_doc_ope', o: 'isNull' },
                  { m: model, f: 'p_doc_ope', o: '=', v: '1' },
                  { m: model, f: 'p_doc_ope', o: '=', v: '0' }
                ]
              })
            } else {
              where.aAnd.push({
                aOr: [
                  { m: model, f: 'p_doc_ope', o: 'isNull' },
                  { m: model, f: 'p_doc_ope', o: '=', v: '1' }
                ]
              })
            }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              where.aAnd.push({ m: model, f: 'dem_status', o: '=', v:  this.filtros.dem_sta.join() })
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: model, f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: model, f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: model, f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break
        }

        // VERIFICA SE DEVE INCLUIR FILTRO DE PESQUISA DE PRODUTO
        if (demanda.indexOf('servico') === -1) {
          if (this.filtros.pro === '__NENHUM__') {
            where.aAnd.push({ f: 'id_pro', o: '=', v: '' })
          } else {
            // SETA A BUSCA DO PRODUTO ESPECIFICADO
            if (this.filtros.pro !== '') {
              where.aAnd.push({ f: 'id_pro', o: 'in', v: this.filtros.pro.join() })
            }
    
            // SETA A BUSCA DO CATEGORIA DE PRODUTO ESPECIFICADO
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ m: 'produto', f: 'id_cat', o: 'in', v: this.filtros.pro_cat.join() })
            }
    
            // SETA A BUSCA DO MARCA DE PRODUTO ESPECIFICADO
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ m: 'produto', f: 'id_mar', o: 'in', v: this.filtros.pro_mar.join() })
            }
          }
        }

        // VERIFICA O STATUS QUE DEVE BUSCAR
        if (this.filtros.tpnf !== '') {
          // INICIA O VETOR
          var tpNF = []

          // RODA O VETOR MONTANDO AS OPÇÕES
          for (var indexTP in this.filtros.tpnf) {
            switch (this.filtros.tpnf[indexTP]) {
              case '0':
                tpNF.push({ aAnd: [ { m: model, f: 'p_doc_docs', o: '<>', v: '0' }, { m: model, f: 'p_doc_ope', o: '=', v: '0' } ] })
                break
  
              case '1':
                tpNF.push({ aAnd: [ { m: model, f: 'p_doc_docs', o: '<>', v: '0' }, { m: model, f: 'p_doc_ope', o: '=', v: '1' } ] })
                break
    
              case '101':
                tpNF.push({ aAnd: [ { m: model, f: 'p_doc_docs', o: '<>', v: '0' }, { aOr: [ { m: model, f: 'p_doc_ope', o: '=', v: '0' }, { m: model, f: 'p_doc_ope', o: '=', v: '1' } ] } ] })
                break
  
              case '102':
                tpNF.push({ m: model, f: 'p_doc_docs', o: '=', v: '0' })
                break
            }
          }

          // VERIFICA TEM QUE COLOCAR O OR OU NÃO
          if (tpNF.length === 1) {
            where.aAnd.push(tpNF[0])
          } else if (tpNF.length >= 2) {
            where.aAnd.push({ aOr: tpNF })
          }
        }

        // RETORNA O WHERE MONTADO
        return where
      },
      demRelPorPeriodoMontarGroup: function (demanda) {
        // INICIA O WHERE QUE SERÁ REALIZADO
        var group = []

        // PEGA O TIPO DE RELATORIO
        var tprel = typeof this.filtros.tprel === 'string' ? this.filtros.tprel : this.filtros.tprel.id

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda + '_' + tprel) {
          case 'venda_produto_1':
          case 'venda_produto_2':
          case 'venda_produto_3':
            group = [
              { m: 'venda', f: 'vencimento', o: 'year' },
              { m: 'venda', f: 'vencimento', o: 'month' },
              { m: 'venda', f: 'vencimento', o: 'day' },
              'id_pro'
            ]
            break
          case 'venda_produto_4':
          case 'venda_produto_5':
          case 'venda_produto_6':
            group = [
              { m: 'venda', f: 'vencimento', o: 'year' },
              { m: 'venda', f: 'vencimento', o: 'month' },
              'id_pro'
            ]
            break
            
          case 'venda_servico_1':
          case 'venda_servico_2':
          case 'venda_servico_3':
            group = [
              { m: 'venda', f: 'vencimento', o: 'year' },
              { m: 'venda', f: 'vencimento', o: 'month' },
              { m: 'venda', f: 'vencimento', o: 'day' },
              'id_ser'
            ]
            break
          case 'venda_servico_4':
          case 'venda_servico_5':
          case 'venda_servico_6':
            group = [
              { m: 'venda', f: 'vencimento', o: 'year' },
              { m: 'venda', f: 'vencimento', o: 'month' },
              'id_ser'
            ]
            break

          case 'compra_produto_1':
          case 'compra_produto_2':
          case 'compra_produto_3':
            group = [
              { m: 'demanda', f: 'vencimento', o: 'year' },
              { m: 'demanda', f: 'vencimento', o: 'month' },
              { m: 'demanda', f: 'vencimento', o: 'day' },
              'id_pro'
            ]
            break
          case 'compra_produto_4':
          case 'compra_produto_5':
          case 'compra_produto_6':
            group = [
              { m: 'demanda', f: 'vencimento', o: 'year' },
              { m: 'demanda', f: 'vencimento', o: 'month' },
              'id_pro'
            ]
            break
        }

        // RETORNA O VALOR MONTADO
        return group
      },
      demRelPorPeriodoMontarPesquisa: function (chave) {
        // INICIA A VARIAVEL
        var pesquisa = { rota: this.demRelPorPeriodoMontarRouter(chave), metodo: this.demRelPorPeriodoMontarMethod(chave) }

        // VERIFICA A DEMANDA QUE DEVE MONTAR
        switch (chave) {
          case 'venda_produto_data_ini_fim':
          case 'venda_servico_data_ini_fim':
          case 'compra_produto_data_ini_fim':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1 } }
            
            // MONTA O FIELD QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.demRelPorPeriodoMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.demRelPorPeriodoMontarWhere(chave)
            break

          case 'venda_produto':
          case 'venda_servico':
          case 'compra_produto':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1000 } }
            
            // MONTA O FIELD QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.demRelPorPeriodoMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.demRelPorPeriodoMontarWhere(chave)

            // MONTA O GROUP QUE SERÁ REALIZADO
            pesquisa.parametro.group = this.demRelPorPeriodoMontarGroup(chave)
            break

            case 'venda_produto_grafico':
            case 'venda_servico_grafico':
            case 'compra_produto_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1000 } }
            
            // MONTA O FIELD QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.demRelPorPeriodoMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.demRelPorPeriodoMontarWhere(chave)

            // MONTA O GROUP QUE SERÁ REALIZADO
            pesquisa.parametro.group = this.demRelPorPeriodoMontarGroup(chave)
            break
        }

        // RETORNA O VALOR MONTADO
        return JSON.parse(JSON.stringify(pesquisa))
      },
      demRelPorPeriodoBuscarTodosRegistros: function (querys, qtdeProBus = 0, qtdeProTot = null, qtdeSerBus = 0, qtdeSerTot = null, registros = [], success = null) {
        if (success === null) {
          return new Promise((successP) => { this.demRelPorPeriodoBuscarTodosRegistros(querys, qtdeProBus, qtdeProTot, qtdeSerBus, qtdeSerTot, registros, successP) })
        } else if (Object.keys(querys).length === 0 || ((qtdeProTot === null && qtdeSerTot === null) === false && qtdeProBus >= qtdeProTot && qtdeSerBus >= qtdeSerTot)) {
          success(registros)
        } else {
          // INICIA A VARIAVEIS
          var queryGet = {}

          // VERIFICA SE É A PRIMEIRA BUSCA
          if (qtdeProTot === null && qtdeSerTot === null) {
            queryGet = JSON.parse(JSON.stringify(querys))
          } else {
            // INICIA AS VARIAVEIS
            var qtdeBus = 0
            var qtdeTot = 0
            var qtdeSQL = 0
            var chave = ''
            
            // RODA O VETOR MONTANDO AS PESQUISAS
            for (var indexQ in querys) {
              if (indexQ.indexOf('_grafico') === -1 && indexQ.indexOf('_data_ini_fim') === -1) {
                // VERIFICA SE É PRODUTO OU SERVIÇO
                if (indexQ.indexOf('produto') !== -1) {
                  qtdeBus = qtdeProBus
                  qtdeTot = qtdeProTot
                } else {
                  qtdeBus = qtdeSerBus
                  qtdeTot = qtdeSerTot
                }

                // VERIFICA SE TEM REGISTRO A BUSCAR
                if (qtdeTot > qtdeBus) {
                  for (var i = qtdeBus; i <= qtdeTot; i = (i + 1000)) {
                    if (i >= 0) {
                      // SETA O NOME DA CHAVE
                      chave = indexQ + '_' + qtdeSQL
      
                      // SETA A QUERY INICIAL
                      queryGet[chave] = JSON.parse(JSON.stringify(querys[indexQ]))
      
                      // ALTERA O REGISTRO INICIAL
                      queryGet[chave].parametro.limit.row = i
  
                      // SOMA A QUANTIDADE DE SELECTS REALIZADOS
                      qtdeSQL++
                    }
                  }
                }
              }
            }
          }

          // FAZ A BUSCA SOLICITADA
          this.$store.state.comunicaAPI('/rota-multipla', 'POST', queryGet, (retorno) => {
            // VERIFICA SE DEU ALGUM ERRO
            var erro = false

            // INICIA VALORES GRAFICO
            var grafico = []

            // INICIA A VARIAVEL
            var datas = {}
            var item = null
            
            // JUNTA OS VALORES RECEBIDOS
            for (var index in retorno) {
              if (retorno[index].code !== '200') {
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno[index])

                // SETA O STATUS NA TELA
                this.demRelPorPeriodoSetarStatusGeral(retorno[index])

                // SETA O FLAG QUE FOI IDENTIFICADO UM ERRO
                erro = true

                // PARA DE RODAR O VETOR
                break
              } else if (index.indexOf('_data_ini_fim') !== -1) {
                // VERIFICA SE TEM VALOR RECEBIDO
                item = retorno[index].data.length >= 1 ? retorno[index].data[0] : null
  
                // VERIFICA SE TEM VALOR RECEBIDO
                if (item !== null) {                      
                  // CONVERTE O VALOR RECEBIDO
                  item.time_min = moment(item.vcto_min, 'DD/MM/YYYY').format('X').toString()
  
                  // CONVERTE O VALOR RECEBIDO
                  item.time_max = moment(item.vcto_max, 'DD/MM/YYYY').format('X').toString()
                  
                  // SETA OS VALORES MONTADOS
                  datas[item.time_min] = item.vcto_min
                  datas[item.time_max] = item.vcto_max
                }
              } else if (index.indexOf('_grafico') !== -1) {
                grafico = grafico.concat(retorno[index].data)
              } else if (retorno[index].data !== undefined && retorno[index].data.length >= 1) {
                // JUNTA OS VALORES RECEBIDOS
                registros = registros.concat(retorno[index].data)

                // VERIFICA SE ESTÁ TRATANDO PRODUTO OU SERVIÇO
                if (index.indexOf('produto') !== -1) {
                  qtdeProBus += retorno[index].data.length
                } else {
                  qtdeSerBus += retorno[index].data.length
                }
              }
            }
            
            // VERIFICA SE DEU ALGUM ERRO NO REQUEST
            if (erro === false) {
              // VERIFICA SE TEM DATA A SETAR
              if (Object.keys(datas).length >= 1) {
                // PEGA AS COLUNAS PARA ORDENAR
                var _vetor = JSON.parse(JSON.stringify(datas))

                // ORDENA O VETOR
                datas = Object.keys(_vetor).sort().reduce((vet, index) => {
                  // SETA O VALOR PARA O NOVO VETOR
                  vet[index] = datas[index]

                  // RETORNA O NOVO VETOR
                  return vet
                }, {})

                // PEGA AS CHAVE DAS DATAS
                item = Object.keys(datas)

                // MONTA A DATA INICIAL E FINAL DA PESQUISA
                this.demRelPorPeriodoMontarDataIniDataFimPesquisa(datas[item[0]], datas[item[(item.length - 1)]])
              }

              // VERIFICA SE DEVE SETAR OS TOTAIS ENCONTRADOS
              if (qtdeProTot === null && qtdeSerTot === null) {
                // SETA A QUANTIDADE DE PRODUTOS EXISTENTES
                if (this.cpntDemanda === 'venda') {
                  qtdeProTot = [ '', null, undefined ].indexOf(retorno.venda_produto) === -1 ? Number(retorno.venda_produto.countAll) : 0
                } else {
                  qtdeProTot = [ '', null, undefined ].indexOf(retorno.compra_produto) === -1 ? Number(retorno.compra_produto.countAll) : 0
                }

                // SETA A QUANTIDADE DE SERVIÇOS EXISTENTES
                qtdeSerTot = [ '', null, undefined ].indexOf(retorno.venda_servico) === -1 ? Number(retorno.venda_servico.countAll) : 0
              }

              // REINICIA O PROCESSO DE BUSCA
              this.demRelPorPeriodoBuscarTodosRegistros(querys, qtdeProBus, qtdeProTot, qtdeSerBus, qtdeSerTot, registros, success)
            }
          }, this.demRelPorPeriodoSetarStatusGeral)
        }
      },
      appHisMontarColunaGrafico: function (data) {
        // INICIA A VARIAVEL
        var nome = ''
        var ini = ''
        var fim = ''

        // MONTA O NOME DA COLUNA NO GRAFICO
        if (this.params.qtdeMes <= 1) {
          // PEGA A DATA INICIAL DA COLUNA
          ini = moment(data, 'DD/MM/YYYY')

          // PEGA A DATA FINAL
          fim = moment(data, 'DD/MM/YYYY')

          // MONTA O NOME DA COLUNA
          nome = ini.format('DD/MM/YYYY')
        } else if (this.params.qtdeMes <= 4) {
          // PEGA A DATA INICIAL DA COLUNA
          ini = moment(data, 'DD/MM/YYYY').startOf('week')

          // VERIFICA A DATA INICIAL
          if (ini.diff(moment(this.params.dataIni, 'DD/MM/YYYY'), 'days', true) < 0) {
            ini = moment(this.params.dataIni, 'DD/MM/YYYY')
          }

          // PEGA A DATA FINAL
          fim = moment(data, 'DD/MM/YYYY').endOf('week')

          // VERIFICA A DATA INICIAL
          if (fim.diff(moment(this.params.dataFim, 'DD/MM/YYYY'), 'days', true) > 0) {
            fim = moment(this.params.dataFim, 'DD/MM/YYYY')
          }

          // MONTA O NOME DA COLUNA
          nome = ini.format('DD/MM/YYYY') + ' à ' + fim.format('DD/MM/YYYY')
        } else if (this.params.qtdeMes >= 30) {
          // PEGA A DATA INICIAL DA COLUNA
          ini = moment(data, 'DD/MM/YYYY')

          // VERIFICA A QUANTIDADE DE DATAS PARA O GRAFICO
          switch (ini.format('MM')) {
            case '01':
            case '02':
              // SETA A DATA INICIAL
              ini = moment('01/01/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '01/' + ini.format('YYYY') + ' à ' + '02/' + ini.format('YYYY')
              break

            case '03':
            case '04':
              // SETA A DATA INICIAL
              ini = moment('01/03/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '03/' + ini.format('YYYY') + ' à ' + '04/' + ini.format('YYYY')
              break

            case '05':
            case '06':
              // SETA A DATA INICIAL
              ini = moment('01/05/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '05/' + ini.format('YYYY') + ' à ' + '06/' + ini.format('YYYY')
              break

            case '07':
            case '08':
              // SETA A DATA INICIAL
              ini = moment('01/07/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '07/' + ini.format('YYYY') + ' à ' + '08/' + ini.format('YYYY')
              break

            case '09':
            case '10':
              // SETA A DATA INICIAL
              ini = moment('01/09/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '09/' + ini.format('YYYY') + ' à ' + '10/' + ini.format('YYYY')
              break

            case '11':
            case '12':
              // SETA A DATA INICIAL
              ini = moment('01/11/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '11/' + ini.format('YYYY') + ' à ' + '12/' + ini.format('YYYY')
              break
          }
        } else {
          // CARREGA A DATA
          ini = moment(data, 'DD/MM/YYYY').startOf('month')

          // MONTA O NOME DA COLUNA
          nome = ini.format('MM/YYYY')
        }
        
        // RETORNA O VALOR
        return { nome: nome, time: ini.format('X').toString() }
      },
      demRelPorPeriodoMontarGraficoDados: function (vetor) {
        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }

        // PEGA O TIPO DE RELATORIO
        var tprel = typeof this.filtros.tprel === 'string' ? this.filtros.tprel : this.filtros.tprel.id

        // INICIA AS VARIAVEIS
        var chaves = null
        var cor = null
        var colunas = []
        var valores = { data: [], fill: false, backgroundColor: [], borderColor: [], borderWidth: 1 }

        // IMPORTA A FUNÇAO
        const FUN_RANDOM_COLOR = require('@/assets/js/Funcoes-Gerais.js').FUN_RANDOM_COLOR

        // RODA UM VETOR PARA MONSTAR OS DADOS
        for (var data in vetor) {
          if ([ '1', '2', '3' ].indexOf(tprel) !== -1) {
            // PEGA OS VALORES RECEBIDOS
            chaves = this.appHisMontarColunaGrafico(data)
            
            // VERIFICA SE A COLUNA JÁ EXISTE
            if (valores.data[chaves.time] === undefined) {
              // SETA O NOME DA COLUNA NO GRAFICO
              colunas.push(chaves.nome)

              // INICIA O VALOR PARA SEMANA
              valores.data[chaves.time] = 0

              // GERA AS NOVAS CORRES PARA OS CAMPOS
              cor = FUN_RANDOM_COLOR()

              // COLOCA AS CORES PARA CADA BARRA
              valores.backgroundColor.push(cor[0])
              valores.borderColor.push(cor[1])
            }

            // SOMA O VALOR PARA SEMANA
            valores.data[chaves.time] += Number(vetor[data])
          } else {
            // GERA AS NOVAS CORRES PARA OS CAMPOS
            cor = FUN_RANDOM_COLOR()

            // SETA O NOME DA COLUNA NO GRAFICO
            colunas.push(data)

            // SETA O VALOR PARA O GRAFICO
            valores.data.push(vetor[data])

            // COLOCA AS CORES PARA CADA BARRA
            valores.backgroundColor.push(cor[0])
            valores.borderColor.push(cor[1])
          }
        }
        
        // CONVERTE O VALOR EM ARRAY
        if ([ '1', '2', '3' ].indexOf(tprel) !== -1) {
          valores.data = Object.values(valores.data)
        }

        // MOSTRA O GRAFICO
        this.grafico = ''

        // SETA A QUANTIDADE DE COLUNAS NO GRAFICO
        this.params.qtdeG = colunas.length
        
        // CHAMA A FUNÇÃO PRA MONTAR O GRAFICO NA TELA
        this.demRelPorPeriodoMontarGraficoTela(colunas, valores)
      },
      demRelPorPeriodoMontarGraficoTela: function (colunas, valores, tentativa = 0) {
        if (tentativa <= 10 && this.$refs.grafico === undefined) {
          setTimeout(() => { this.demRelPorPeriodoMontarGraficoTela(colunas, valores, (tentativa + 1)) }, 500)
        } else if (this.$refs.grafico !== undefined) {
          // PEGA O TIPO DE RELATORIO
          var tprel = typeof this.filtros.tprel === 'string' ? this.filtros.tprel : this.filtros.tprel.id

          // IMPORTA A FUNÇÃO
          const Chart = require('chart.js')

          // INICIA A VARIAVEL
          var titulo = ''

          // VERIFICA O TITULO DO CAMPO
          switch (tprel) {
            case '1':
            case '4':
              titulo = 'Ticket Médio R$'
              break

            case '2':
            case '5':
              titulo = 'Valor Total R$'
              break

            case '3':
            case '6':
              titulo = 'Quantidade'
              break
          }
  
          // SETA O GRAFICO NA TELA
          this.grafico = new Chart(this.$refs.grafico, {
            type: 'bar',
            data: {
              labels: Object.values(colunas),
              datasets: [ valores ]
            },
            options: {
              legend: {
                display: false
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      minRotation: 45
                    },
                    scaleLabel: {
                      display: false
                    }
                  }
                ],
                yAxes: [ 
                  {
                    scaleLabel: {
                      display: true,
                      labelString: titulo
                    },
                    ticks: {
                      beginAtZero: true,
                      callback: (label) => {
                        switch (tprel) {
                          case '1':
                          case '2':
                          case '4':
                          case '5':
                            return this.$store.state.FUN_MASK_VALOR('valorMoeda', (label * 100).toFixed(0).toString())

                          case '3':
                          case '6':
                            return this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', label.toString())
                        }
                      }
                    }
                  }
                ]
              },
              tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                  label: (item) => {
                    switch (tprel) {
                      case '1':
                      case '4':
                        return 'Ticket Médio: R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())

                      case '2':
                      case '5':
                        return 'Venda Total: R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())

                      case '3':
                      case '6':
                        return 'Quantidade: ' + this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', item.value.toString())
                    }
                  }
                }
              }
            }
          })
        }
      },
      demRelPorPeriodoPesquisar: function () {
        // SETA O STATUS DE CARREGANDO
        this.pesquisa = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE AGUARDAR CARREGAMENTO
        if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat._dataIni === undefined)) {
          // return 
          setTimeout(() => { this.demRelPorPeriodoPesquisar() }, 50)
        } else {
          // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
          this.tabper = this.$store.state.mPer[this.mper.tabper]
    
          // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
          if (this.tabper.flag !== false) {
            // SETA AS COLUNAS MARCADAS
            for (var indexC in this.mper.fieldOptions) {
              // OCULTA TODAS AS COLUNAS OPCIONAIS
              if (this.mper.fieldOptions[indexC].mPer === 1) {
                this.mper.fieldOptions[indexC].mPer = 0
              }
    
              // VERIFICA SE A COLUNA DEVE SER APRESENTADA
              if (this.mper.fieldOptions[indexC].mPer === 0 && this.tabper.field.indexOf(this.mper.fieldOptions[indexC].chave) !== -1) {
                this.mper.fieldOptions[indexC].mPer = 1
              }
            }
          }

          // SETA AS COLUNAS
          this.colunas = JSON.parse(JSON.stringify(this.mper.fieldOptions))

          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // LIMPA AS VARIAVEIS
          this.params.qtdeMes = null
          this.params.dataIni = ''
          this.params.dataFim = ''

          // MONTA A DATA INICIAL E FINAL DA PESQUISA
          if (this.filtros.dat !== '') {
            this.demRelPorPeriodoMontarDataIniDataFimPesquisa(this.filtros.dat.dataIni, this.filtros.dat.dataFim)
          }

          // INICIA A VARIAVEL
          var pesquisa = []

          // ADICIONA A BUSCA DO PRODUTO
          if (this.filtros.pro !== '__NENHUM__' && this.permissoes.pro === true) {
            pesquisa.push(this.cpntDemanda + '_produto')
          }

          // ADICIONA A BUSCA DO PRODUTO
          if (this.filtros.ser !== '__NENHUM__' && this.permissoes.ser === true && this.cpntDemanda === 'venda') {
            pesquisa.push(this.cpntDemanda + '_servico')
          }

          // INICIA AS VARIAVEIS
          var querys = {}
          var chave = ''

          // MONTA TODOS OS REQUESTS PARA API
          for (var indexP in pesquisa) { 
            // ADICIONA A PESQUISA MONTADA AO VETOR
            chave = pesquisa[indexP]
            querys[chave] = this.demRelPorPeriodoMontarPesquisa(chave)
  
            // VERIFICA SE TEM DATA NO RELATORIO
            if (this.params.qtdeMes === null) {
              chave = pesquisa[indexP] + '_data_ini_fim'
              querys[chave] = this.demRelPorPeriodoMontarPesquisa(chave)
            }
          }

          // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
          this.demRelPorPeriodoBuscarTodosRegistros(querys).then((registros) => { this.demRelPorPeriodoTratarValores(registros) })
        }
      },
      demRelPorPeriodoTratarValores: function (retorno) { 
        // INICIA AS VARIAVEIS A SEREM UTILIZADAS
        var modo = ''
        var mapa = {}
        var grafico = {}
        var data = ''
        var chaveV = ''
        var linhas = []

        // PEGA O TIPO DE RELATORIO
        var tprel = typeof this.filtros.tprel === 'string' ? this.filtros.tprel : this.filtros.tprel.id

        // VERIFICA O TIPO DE RELATORIO QUE SERÁ MONTADO
        switch (tprel) {
          case '1':
          case '2':
          case '3':
            modo = { diff: 'days', add: 'd' }
            break

          case '4':
          case '5':
          case '6':
            modo = { diff: 'months', add: 'M' }
            break
        }
        
        // CALCULA A QUANTIDADE DE MESES
        var qtde = Math.ceil(moment(this.params.dataFim, 'DD/MM/YYYY').diff(moment(this.params.dataIni, 'DD/MM/YYYY'), modo.diff, true))
        
        // CALCULA OS DIAS
        if ([ '1', '2', '3' ].indexOf(tprel) !== -1) {
          qtde = (qtde + 1)
        }

        // SETA A QUANTIDADE DE COLUNAS
        this.params.qtdeT = qtde

        // RODA O FOR ADICIONANDO OS VALORES
        for (var i = 1; i <= qtde; i++) {
          // CARREGA A DATA QUE DEVE CUSAR
          data = moment(this.params.dataIni, 'DD/MM/YYYY')
          
          // PEGA DA DATA INICIAL E ADICONA O VALOR
          if (data >= 2) {
            data = data.add((i - 1).toString(), modo.add)
          }

          // FORMATA A DATA CALCULADA
          if ([ '1', '2', '3' ].indexOf(tprel) !== -1) {
            data = data.format('DD/MM/YYYY')
          } else if ([ '4', '5', '6' ].indexOf(tprel) !== -1) {
            data = data.format('MM/YYYY')
          }
            
          // VERIFICA SE ESSA DATA JÁ FOI PROCESSADA
          if (mapa[data] === undefined) {
            mapa[data] = { qtde: 0, valor: 0, item: 0 }
          }
        }

        // SETA O VALOR INICIAL DOS TOTAIS
        var totais = JSON.parse(JSON.stringify(mapa))

        // IMPORTA A FUNÇAO
        const CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM = require('@/assets/js/Funcoes-Gerais.js').CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM

        // INICIA O PROCESSO
        var tipo = ''

        // RODA AS LINHAS RECEBIDAS
        for (var indexR in retorno) {
          // VERIFICA O TIPO DE REGISTRO
          if (retorno[indexR].id_pro !== undefined) {
            // SETA O TIPO DE REGISTRO
            retorno[indexR].item_tipo = 'Produto'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'produto'
          } else {
            // SETA O TIPO DE REGISTRO
            retorno[indexR].item_tipo = 'Serviço'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'servico'
          }

          // MANDA CALCULAR OS VALORES
          retorno[indexR] = CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno[indexR], tipo, {
            qtde:             'qtde_sum',
            valor_tot:        'valor_tot_sum',
            valor_fre:        'valor_fre_sum',
            valor_seg:        'valor_seg_sum',
            valor_des:        'valor_des_sum',
            valor_oda:        'valor_oda_sum',
            p_icms_st_v:      'p_icms_st_v_sum',
            p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
            p_ipi_v:          'p_ipi_v_sum'
          })

          // MONTA O NOME DA CHAVE
          if ([ '', null, undefined ].indexOf(retorno[indexR].id_pro) === -1) {
            chaveV = 'p_' + retorno[indexR].id_pro
          } else {
            chaveV = 's_' + retorno[indexR].id_ser
          }

          // MONTA A DATA RECEBIDA DA API
          if ([ '1', '2', '3' ].indexOf(tprel) !== -1) {
            data = moment(retorno[indexR].demandaId_data_day + '/' + retorno[indexR].demandaId_data_month + '/' + retorno[indexR].demandaId_data_year, 'DD/MM/YYYY').format('DD/MM/YYYY')
          } else if ([ '4', '5', '6' ].indexOf(tprel) !== -1) {
            data = moment('01/' + retorno[indexR].demandaId_data_month + '/' + retorno[indexR].demandaId_data_year, 'DD/MM/YYYY').endOf('month').format('MM/YYYY')
          }

          // VERIFICA SE A CHAVE JÁ EXISTE
          if (linhas[chaveV] === undefined) {
            linhas[chaveV] = Object.assign(JSON.parse(JSON.stringify(retorno[indexR])), JSON.parse(JSON.stringify(mapa)))
          }
          if (linhas[chaveV][data] === undefined) {
            linhas[chaveV][data] = { qtde: 0, valor: 0, item: 0 }
          }
          if (totais[data] === undefined) {
            totais[data] = { qtde: 0, valor: 0, item: 0 }
          }

          // SOMA OS VALORES RECEBIDOS NA LINHA EM QUESTÃO
          linhas[chaveV][data].item += 1
          linhas[chaveV][data].qtde   += Number(retorno[indexR].qtde_sum)
          linhas[chaveV][data].valor  += Number(retorno[indexR].total)
          
          // SOMA OS VALORES NO TOTAL
          totais[data].qtde   += Number(retorno[indexR].qtde_sum)
          totais[data].valor  += Number(retorno[indexR].total)
        }

        // FAZ A FORMATAÇÃO DOS VALORES
        for (var indexL in linhas) {
          for (data in mapa) {
            if (linhas[indexL][data].item === 0) {
              linhas[indexL][data] = '---'
            } else {
              // TRATA OS VALORES MONTADOS PARA CADA ITEM
              if ([ '1', '4' ].indexOf(tprel) !== -1) {
                linhas[indexL][data] = (Number(linhas[indexL][data].qtde) === 0 ? '0' : (Number(linhas[indexL][data].valor) / Number(linhas[indexL][data].qtde)).toFixed(2)).toString()
              } else if ([ '2', '5' ].indexOf(tprel) !== -1) {
                linhas[indexL][data] = linhas[indexL][data].valor.toString()
              } else if ([ '3', '6' ].indexOf(tprel) !== -1) {
                linhas[indexL][data] = linhas[indexL][data].qtde.toString()
              }
              
              // FORMATA OS VALORES QUE DEVE UTILIZAR
              linhas[indexL][data] = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linhas[indexL][data].toString())
            }
          }
        }

        // SETA AS COLUNAS NA TABELA
        for (data in mapa) {
          // ADICIONA A COLUNA NO VETOR
          this.colunas.push({ mPer: 3, chave: data, nome: data })

          // TRATA OS VALORES MONTADOS PARA CADA ITEM
          if ([ '1', '4' ].indexOf(tprel) !== -1) {
            totais[data] = (Number(totais[data].qtde) === 0 ? '0' : (Number(totais[data].valor) / Number(totais[data].qtde)).toFixed(2)).toString()
          } else if ([ '2', '5' ].indexOf(tprel) !== -1) {
            totais[data] = totais[data].valor.toFixed(2).toString()
          } else if ([ '3', '6' ].indexOf(tprel) !== -1) {
            totais[data] = totais[data].qtde.toFixed(4).toString()
          }

          // SETA O VALOR MONTADO PARA O GRAFICO
          grafico[data] = Number(totais[data])

          // FORMATA OS VALORES QUE DEVE UTILIZAR
          totais[data] = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', totais[data].toString())
        }

        // LIBERA O CARREGAMENTO DO GRAFICO
        setTimeout(() => { this.demRelPorPeriodoMontarGraficoDados(grafico) }, 0)

        // CONVERTE O VALOR EM ARRAY
        linhas = Object.values(linhas)

        // ADICIONA A LINHA DE TOTAIS
        if (linhas.length >= 1) {
          linhas.push(totais)
        }

        // SETA AS LINHAS DAS TABELAS
        this.linhas = linhas

        // SETA O STATUS DE CARREGANDO
        this.pesquisa = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    computed: {
      demRelPorPeriodoContarColunasLinha1: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 1

        // VERIFICA SE TEM O PACOTE VEICULO
        qtde = (qtde + (this.permissoes.vei === true ? 1 : 0))

        // VERIFICA SE TEM O PACOTE PET
        qtde = (qtde + (this.permissoes.pet === true ? 1 : 0))

        // RETORNA O VALOR
        return qtde
      },
      demRelPorPeriodoQtdeRegistro: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 0

        // VERIFICA SE TEM REGISTRO
        if ([ '', null, undefined ].indexOf(this.params) === -1) {
          qtde = [ '', null, undefined ].indexOf(this.params.contatosIds) === -1 ? Number(this.params.contatosIds.length) : 0
        }

        // RETORNA O VALOR
        return qtde
      }
    }
  }
</script>
